// Follow-up feedback is a new review with its own createdAt and parentReviewId.
// Administrator replies/read status must not move a user's group to the top.
export function sortAdminReviewSubmissions(rows = []) {
    const submittedAt = row => Date.parse(row.createdAt) || 0;
    return [...rows].sort((a, b) => submittedAt(b) - submittedAt(a) || Number(b.id) - Number(a.id));
}
